<template>
  <DialogLayout :class-name="'announcement-dialog'" @close="handleClose" :style="{ width: '600px' }">
    <template #title>{{ props.title }}</template>
    <template #default>
      <div class="announcement-content">
        <div class="content-text" v-html="formatContent(props.content)"></div>
      </div>
    </template>
    <template #footer>
      <div class="dialog-footer-wrapper">
        <el-button
          class="confirm-button"
          type="primary"
          @click="handleConfirm"
        >
          {{ t('notify.announcementDialog.confirm') }}
        </el-button>
      </div>
    </template>
  </DialogLayout>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import DialogLayout from '@/components/business-components/dialog/dialog-layout.vue';
import type { AnnouncementDialogProps } from './announcement-dialog-types';

const props = defineProps<AnnouncementDialogProps>();

const emit = defineEmits<{
  confirm: [];
  close: [];
}>();

const { t } = useI18n();

// 格式化内容，将换行符转换为 <br>
const formatContent = (content: string): string => {
  if (!content) return '';
  // 将 \n 转换为 <br>，并转义 HTML 特殊字符
  return content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\n/g, '<br>');
};

const handleConfirm = () => {
  emit('confirm');
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.announcement-dialog {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}

.announcement-content {
    border-radius: 8px;
    opacity: 1;
    padding: 20px;
    background: #F8F9FA; 
  
  .content-text {
    font-size: 14px;
    line-height: 24px;
    color: #212429;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-word;
  }
}

.dialog-footer-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
 
  
  .confirm-button {
    min-width: 120px;
    height: 40px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
  }
}

:deep(.dialog-content) {
  padding: 0 30px;
  max-height: 60vh;
  overflow-y: auto;
}

:deep(.dialog-header) {
  justify-content: center;
  
  .dialog-title {
    text-align: center;
    flex: none;
  }
  
  .dialog-close {
    position: absolute;
    right: 30px;
  }
}

:deep(.dialog-footer) {
  padding: 24px 30px 30px;
  justify-content: center;
}
</style>
